import { Component, OnDestroy, OnInit } from '@angular/core';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { ReportsService } from 'src/app/features/reports/reports.service';
import { formatDate } from '@angular/common';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-sales-summary-smart',
  template: `<app-sales-summary [sales]="sales" [summary]="summary"></app-sales-summary>`,
  styles: [
  ]
})
export class SalesSummarySmartComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {

  sales: any =[];
  summary: any = [];

  constructor(private reportsService: ReportsService) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit()
    //new Date(date.getFullYear(), 0, 1)
    let curdate = new Date().getFullYear().toString() +'-01-01';
    let endDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    let startDate = formatDate(curdate, 'yyyy-MM-dd', 'en');
    let params: any = new HttpParams().set('startDate', startDate).set('endDate', endDate )


    this.reportsService.getsalesSummary(params).subscribe(res => {
      let resData: any = res;
      if (resData.httpcode == 200) {
        resData = resData.data;
        this.summary = resData;
      }
    })    
	
    this.reportsService.getsales(params).subscribe(res => {
      let resData: any = res;
      if (resData.httpcode == 200) {
        resData = resData.data;
        this.sales=resData;
      }
    })
	}

  ngOnDestroy() {
    super.ngOnDestroy()
  }
  
}
